import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { N0DES_API_PREFIX } from "@/api/domain"
import type { IrohNode, ProjectIdParam } from "@/types"

// Define a service using a base URL and expected endpoints
export const irohNodesApi = createApi({
  reducerPath: "irohNodesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${N0DES_API_PREFIX}iroh-nodes`,
    mode: "cors",
    credentials: "include",
  }),
  endpoints: (build) => ({
    irohNodesGet: build.query<
      IrohNode[],
      ProjectIdParam & { offset: number; limit: number }
    >({
      query: ({ project_id, offset, limit }) => ({
        url: `${project_id}?offset=${offset}&limit=${limit}`,
      }),
    }),
  }),
})

export const { useIrohNodesGetQuery } = irohNodesApi
